import { CellContext, ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { AdaptiveTableCell, SliderCheckbox } from '@components/common';
import ChangeMonitoringStatusCell from '@components/routes/AdminPanel/ManageNetworkElementConfigurations/ChangeMonitoring/ChangeMonitoringStatusCell';

import { IAssetVisibilityRestricted } from '@interfaces/assets/assetVisibility';

import { VISIBLE_ACCESS_NAME } from '@components/OrganisationProfile/constants';

const columnHelper = createColumnHelper<IAssetVisibilityRestricted>();

interface IColumns {
	toggleAccess: (id: string, isEnabled: boolean) => void;
	isToggleAccessAvailable: boolean;
}

export const getColumns = ({
	toggleAccess,
	isToggleAccessAvailable,
}: IColumns): ColumnDef<any>[] => [
	columnHelper.accessor('organizationName', {
		header: 'Organisation',
		cell: ({ getValue }: CellContext<IAssetVisibilityRestricted, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value}/>;
		},
	}),
	columnHelper.accessor('accessStatus', {
		header: 'Access control',
		enableSorting: false,
		cell: ({ row: { original } }: CellContext<IAssetVisibilityRestricted, any>) => {
			const { organizationId, accessStatus } = original || {};

			const onChange = () => {
				toggleAccess(organizationId, accessStatus);
			};

			return (
				<SliderCheckbox
					checked={accessStatus}
					disabled={!isToggleAccessAvailable}
					id={organizationId}
					onChange={onChange}
				/>
			);
		},
	}),
	columnHelper.accessor('resultingAccess', {
		header: 'Resulting Access',
		cell: ({ row: { original } }: CellContext<IAssetVisibilityRestricted, any>) => {
			const { resultingAccess, resultingAccessNote } = original || {};

			const isError = !!resultingAccessNote && (resultingAccessNote !== VISIBLE_ACCESS_NAME);

			return (
				<ChangeMonitoringStatusCell
					isError={isError}
					status={resultingAccess}
					tooltipLabel={resultingAccessNote || 'Access restricted by the MNO'}
				/>
			);
		},
	}),
];
